import { 
  collection, 
  addDoc, 
  getDocs, 
  doc, 
  deleteDoc, 
  updateDoc,
  query,
  where,
  orderBy,
  Timestamp 
} from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Save a recipe to Firestore
 */
export async function saveRecipe(userId, recipeData) {
  try {
    const recipeRef = await addDoc(collection(db, 'recipes'), {
      userId,
      name: recipeData.name,
      ingredients: recipeData.ingredients,
      instructions: recipeData.instructions || null,
      source: recipeData.source || 'Unknown',
      imageUrl: recipeData.imageUrl || null,
      tags: recipeData.tags || [],
      isFavorite: false,
      createdAt: Timestamp.now(),
      lastMade: null
    });

    return { id: recipeRef.id, ...recipeData };
  } catch (error) {
    console.error('Error saving recipe:', error);
    throw error;
  }
}

/**
 * Save multiple recipes at once
 */
export async function saveRecipes(userId, recipesArray) {
  try {
    console.log('saveRecipes called with:', { 
      userId, 
      recipesArray, 
      isArray: Array.isArray(recipesArray),
      type: typeof recipesArray 
    });
    
    const promises = recipesArray.map(recipe => saveRecipe(userId, recipe));
    return await Promise.all(promises);
  } catch (error) {
    console.error('Error saving recipes:', error);
    throw error;
  }
}

/**
 * Get all recipes for a user
 */
export async function getUserRecipes(userId) {
  try {
    const q = query(
      collection(db, 'recipes'),
      where('userId', '==', userId),
      orderBy('createdAt', 'desc')
    );

    const querySnapshot = await getDocs(q);
    const recipes = [];

    querySnapshot.forEach((doc) => {
      recipes.push({
        id: doc.id,
        ...doc.data()
      });
    });

    return recipes;
  } catch (error) {
    console.error('Error getting recipes:', error);
    throw error;
  }
}

/**
 * Delete a recipe
 */
export async function deleteRecipe(recipeId) {
  try {
    await deleteDoc(doc(db, 'recipes', recipeId));
  } catch (error) {
    console.error('Error deleting recipe:', error);
    throw error;
  }
}

/**
 * Toggle favorite status
 */
export async function toggleFavorite(recipeId, currentStatus) {
  try {
    const recipeRef = doc(db, 'recipes', recipeId);
    await updateDoc(recipeRef, {
      isFavorite: !currentStatus
    });
  } catch (error) {
    console.error('Error toggling favorite:', error);
    throw error;
  }
}

/**
 * Update last made date
 */
export async function updateLastMade(recipeId) {
  try {
    const recipeRef = doc(db, 'recipes', recipeId);
    await updateDoc(recipeRef, {
      lastMade: Timestamp.now()
    });
  } catch (error) {
    console.error('Error updating last made:', error);
    throw error;
  }
}
